<!--
 * @Description:
 * @Date: 2021-06-21 10:42:05
-->
<template>
  <div class="bi">
    <XrkBi
      :print="print"
      :cantEdit="cantEdit"
      :projectType="projectType"
      :selectType="selectType"
      from="gongye"
      v-bind="config"
      :getTemplateList="getTemplateList"
    ></XrkBi>
  </div>
</template>

<script>
import Xrk from 'xrk-bi';
import {
  biBase,
  makeSceneBi,
  hgtgBi,
  digitalQuestionnaireBi
} from '@/api/ajax';
export default {
  name: 'bi',
  components: {
    [Xrk.Bi.name]: Xrk.Bi
  },
  computed: {
    print() {
      return this.$route.query.print;
    },
    cantEdit() {
      return this.$route.query.cantEdit;
    },
    projectType() {
      return this.$route.query.projectType;
    },
    selectType() {
      return +this.$route.query.selectType;
    },
    config() {
      const that = this;
      const makeSceneAndSurvey = {
        getBaseInfo(data) {
          return that.dealAjax(makeSceneBi.baseInfo, data)();
        },
        getFixedInfo(data) {
          return that.dealAjax(makeSceneBi.fixedInfo, data)();
        },
        getTopicInfo(data) {
          return that.dealAjax(makeSceneBi.topicInfo, data)();
        },
        getGroupInfo(data) {
          return that.dealAjax(makeSceneBi.groupInfo, data)();
        },
        saveInfo(data) {
          return that.dealAjax(makeSceneBi.saveInfo, data)();
        },
        saveBiPicList(data) {
          return that.dealAjax(makeSceneBi.saveBiPicList, data)();
        },
        getTaskPicList(data) {
          return that.dealAjax(makeSceneBi.getTaskPicList, data)();
        },
        getImageList(data) {
          return that.dealAjax(makeSceneBi.getImageList, data)();
        },
        getImageQuestionCount(data) {
          return that.dealAjax(makeSceneBi.getImageQuestionCount, data)();
        },
        exportBi() {
          return `${makeSceneBi.download}?biInfoId=${this.$route.query.biInfoId}`;
        }
      };
      return {
        20: makeSceneAndSurvey,
        5: makeSceneAndSurvey,
        7: makeSceneAndSurvey,
        6: {
          getBaseInfo(data) {
            return that.dealAjax(hgtgBi.baseInfo, data)();
          },
          getFixedInfo(data) {
            return that.dealAjax(hgtgBi.fixedInfo, data)();
          },
          getTopicInfo(data) {
            return that.dealAjax(hgtgBi.topicInfo, data)();
          },
          getGroupInfo(data) {
            return that.dealAjax(hgtgBi.groupInfo, data)();
          },
          saveInfo(data) {
            return that.dealAjax(hgtgBi.saveInfo, data)();
          },
          exportBi() {
            return `${makeSceneBi.download}?biInfoId=${this.$route.query.biInfoId}`;
          }
        },
        21: {
          getBaseInfo(data) {
            return that.dealAjax(digitalQuestionnaireBi.baseInfo, data)();
          },
          getFixedInfo(data) {
            return that.dealAjax(digitalQuestionnaireBi.fixedInfo, data)();
          },
          getTopicInfo(data) {
            return that.dealAjax(digitalQuestionnaireBi.topicInfo, data)();
          },
          getGroupInfo(data) {
            return that.dealAjax(digitalQuestionnaireBi.groupInfo, data)();
          },
          saveInfo(data) {
            return that.dealAjax(digitalQuestionnaireBi.saveInfo, data)();
          },
          exportBi() {
            const loading = this.$loading({
              lock: true
            });
            biBase
              .saveDownLoadTaskByBiInfoId({
                type: this.$route.query.selectType,
                biInfoId: this.$route.query.biInfoId
              })
              .then(() => {
                this.$message.success(
                  '正在生成，生成完后可前往下载中心进行下载'
                );
                loading.close();
              })
              .catch(() => {
                loading.close();
              });
            // return `${makeSceneBi.download}?biInfoId=${this.$route.query.biInfoId}`;
          }
        }
      }[this.projectType];
    }
  },
  methods: {
    getTemplateList(data) {
      return this.dealAjax(makeSceneBi.templateList, data)();
    },
    dealAjax(ajax, data, noUseId) {
      const { biInfoId, fenpeiId, projectId } = this.$route.query;
      if (noUseId) {
        return ajax.bind(null, {
          ...data,
          auth:
            this.projectType == 21 ? '6JD4LEBOOP3XDW2JHPNAQHHEBBF0KCAH' : '',
          fenpeiId,
          projectId
        });
      }
      return ajax.bind(null, {
        ...data,
        auth: this.projectType == 21 ? '6JD4LEBOOP3XDW2JHPNAQHHEBBF0KCAH' : '',
        id: biInfoId,
        biInfoId,
        fenpeiId,
        projectId
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.bi {
  width: 1200px;
  margin: 0 auto;
}
</style>
